import { Box, Card, CardContent, List } from '@mui/material';
import React from 'react';

import { Subheading } from '../../theme/theme';

interface OwnProps {
  title: string;
  children: React.ReactNode;
  // Set false when children are free content (e.g. paragraphs) rather than
  // list items, so they aren't wrapped in a <ul>.
  list?: boolean;
}

const FeatureList: React.FC<OwnProps> = (props) => {
  const { list = true } = props;
  return (
    <Card sx={{ margin: '25px 0', minHeight: '90%' }}>
      <CardContent>
        <Subheading>{props.title}</Subheading>
        {list ? (
          <List>{props.children}</List>
        ) : (
          // Same vertical padding as <List>, so the card's layout is identical.
          <Box sx={{ py: '8px' }}>{props.children}</Box>
        )}
      </CardContent>
    </Card>
  );
};

export default FeatureList;
